import $ from 'jquery';

$(function () {
  // Organisation selection in Popup Modal
  $(document).on('click', '.country-org-card', function () {
    const $card = $(this);
    const $grid = $card.closest('.country-popup-orgs-grid');
    
    // Toggle active state
    $grid.find('.country-org-card').removeClass('active');
    $card.addClass('active');

    // Retrieve data attributes
    const orgName = $card.data('name');
    const orgLocation = $card.data('location');
    const orgDesc = $card.data('desc');

    // Update detail section content
    const $detailBox = $card.closest('.country-popup-bottom').find('.country-popup-org-detail');
    if (orgName && $detailBox.find('#orgDetailTitle').length) {
      $detailBox.find('#orgDetailTitle').text(orgName);
    }
    if (orgLocation && $detailBox.find('#orgDetailLocation').length) {
      $detailBox.find('#orgDetailLocation').text(orgLocation);
    }
    if (orgDesc && $detailBox.find('#orgDetailDesc').length) {
      // Format paragraphs if separated by double newline
      const paragraphs = orgDesc.split('\n\n');
      const htmlContent = paragraphs.map(p => `<p>${p.trim()}</p>`).join('');
      $detailBox.find('#orgDetailDesc').html(htmlContent);
    }
  });

  // Support Partner Card Modal Population
  $(document).on('click', '.partner-card, .sponsors-card[data-bs-toggle="modal"]', function () {
    const $card = $(this);
    const partnerName = $card.data('partner-name') || '';
    const partnerOffice = $card.data('partner-office') || '';
    const partnerDesc = $card.data('partner-desc') || '';
    const partnerLogo = $card.data('partner-logo');
    const isStacked = $card.data('partner-stacked');

    const $modal = $('#partnerDetailModal');
    if (!$modal.length) return;

    $modal.find('#partnerModalTitle').text(partnerName);
    $modal.find('#partnerModalOffice').text(partnerOffice);
    $modal.find('#partnerModalDesc').html(partnerDesc ? `<p>${partnerDesc}</p>` : '');

    const $logoContainer = $modal.find('#partnerModalLogoContainer');
    if (isStacked) {
      $logoContainer.html(`
        <div class="partner-logo-stacked">
          <img src="../assets/images/partners/siemag-1.svg" alt="" class="partner-logo-sub">
          <img src="../assets/images/partners/siemag-2.svg" alt="${partnerName}" class="partner-logo-sub">
        </div>
      `);
    } else if (partnerLogo) {
      $logoContainer.html(`
        <img src="${partnerLogo}" alt="${partnerName}" class="partner-modal-logo-img">
      `);
    }
  });
});
